import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;

    return (
      <div>
        <h3><center><u>GRN Information Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{data.groupID} - {data.operationEntityID}</center></h4>
        <h4><center>{data.date}</center></h4>

        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>GTN Number</TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>Vehicle Number</TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>Driver Name</TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>Transfer VCC</TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>Received VPU</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((row, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell component="th" align="center" scope="row">{row.gtnNumber}</TableCell>
                      <TableCell align="center">{row.vehicleNumber}</TableCell>
                      <TableCell align="center">{row.driverName}</TableCell>
                      <TableCell align="center">{row.vccName}</TableCell>
                      <TableCell align="center">{row.vpuName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography variant="h7" gutterBottom component="div" align="center" >
                          <b>GTN Details</b>
                        </Typography>
                        <Table size="small" aria-label="purchases">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center" style={{ fontWeight: 'bold' }}>Supplier Code</TableCell>
                              <TableCell align="center" style={{ fontWeight: 'bold' }}>Supplier Name</TableCell>
                              <TableCell align="center" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                              <TableCell align="center" style={{ fontWeight: 'bold' }}>Product Name</TableCell>
                              <TableCell align="center" style={{ fontWeight: 'bold' }}>Quantity</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {row.details.map((nestedRow, nestedIndex) => (
                              <TableRow key={nestedIndex}>
                                <TableCell align="center" component="th" scope="row">
                                  {nestedRow.farmerCode}
                                </TableCell>
                                <TableCell align="center">{nestedRow.firstName}</TableCell>
                                <TableCell align="center">{nestedRow.productCode}</TableCell>
                                <TableCell align="center">{nestedRow.productName}</TableCell>
                                <TableCell align="center">{parseFloat(nestedRow.quantity).toFixed(2)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>

          </TableContainer>
        </Box>
      </div>
    );
  }
}
